import React, { useEffect } from 'react';
import { Table, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  BUY,
  ExecutionErrorType,
  ORDER_STATUSES,
  retrieveExecutionErrors,
  retrieveTriedAndFailedOrders,
  selectors,
  TRANSACTION_TYPES,
  TriedAndFailedOrderType,
} from 'state';
import { formatters } from 'services';
import type { TableColumnGroupType as ColumnGroupType, TableColumnType as ColumnType } from 'antd';
import { dateWithTimeSeconds } from 'services/formatters';
import { triedAndFailedOrdersSelector } from '../../../state/app/selectors';

const { Title } = Typography;

const TriedAndFailedOrders: React.FC = () => {
  const dispatch = useDispatch();
  const triedAndFailedOrders = useSelector(
    selectors.triedAndFailedOrdersSelector
  );
  const triedAndFailedOrdersList = Object.values(triedAndFailedOrders.items);

  useEffect(() => {
    if (!triedAndFailedOrders.fetched) {
      dispatch(retrieveTriedAndFailedOrders({}));
    }
  }, []);

  const columns: ((
    | ColumnGroupType<TriedAndFailedOrderType>
    | ColumnType<TriedAndFailedOrderType>
  ) & {
    dataIndex: string;
  })[] = [
    {
      title: 'id',
      dataIndex: 'id',
    },
    {
      title: 'Player',
      dataIndex: 'player',
    },
    {
      title: 'Asset',
      dataIndex: 'asset_name',
    },
    {
      title: 'Type',
      dataIndex: 'order_type',
    },
    {
      title: 'Txn.',
      dataIndex: 'transaction',
      render: (val: keyof typeof TRANSACTION_TYPES) => {
        return TRANSACTION_TYPES[val];
      },
    },
    {
      title: 'Qty.',
      dataIndex: 'quantity',
      render: (val, record) => {
        if (record.transaction === BUY) {
          return formatters.commas1Digit(val);
        } else {
          return formatters.commas1Digit(-val);
        }
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (status: keyof typeof ORDER_STATUSES) => {
        return ORDER_STATUSES[status];
      },
    },
    {
      title: 'Tries',
      dataIndex: 'execution_tries',
    },
  ];

  return (
    <div>
      <Typography.Title level={4}>Tried and Failed orders</Typography.Title>
      <Table
        // style={{ width: '1000px' }}
        columns={columns}
        dataSource={triedAndFailedOrdersList}
        pagination={{ pageSize: 10 }}
        bordered
      />
    </div>
  );
};
// deploy
export default TriedAndFailedOrders;
